import { fetchQuery_DEPRECATED as fetchQuery } from 'relay-runtime';
import { graphql } from 'react-relay/legacy.js';
import { getBuyerId } from 'dibs-cookie-jar';
import { getUserSessionCountryCode } from 'dibs-regional-info/exports/regionalInfoHelpers.ts';
import createEnvironment from '../relayClientEnvironment.ts';
import { init } from './userTracking.js';

const trackingQuery = graphql`
    query initializeTrackingQuery(
        $hasUserId: Boolean!
        $userId: String!
        $fetchTrackingGdprInfo: Boolean = true
        $userCountryCode: String = ""
    ) {
        viewer {
            ...userTracking_viewer @relay(mask: false)
            user(userId: $userId) @include(if: $hasUserId) {
                ...userTracking_user @relay(mask: false)
            }
        }
    }
`;

export default async function initializeTracking(environment) {
    environment = environment || createEnvironment();
    const userId = getBuyerId(document.cookie) || '';
    const hasUserId = !!userId;
    const { viewer } =
        (await fetchQuery(environment, trackingQuery, {
            userId,
            hasUserId,
            userCountryCode: getUserSessionCountryCode(),
        })) || {};
    return init({ viewer, user: viewer?.user, environment });
}
